import type { HomeApiResponse } from '@/domains/home/home.entity';
import type { HomeRepository } from '@/domains/home/home.repository';

/**
 * Use Case para obtener métricas del Home desde el repositorio
 * Cumple ISP: Interface Segregation Principle
 * Cumple DIP: Dependency Inversion Principle (depende de abstracción HomeRepository)
 *
 * Responsabilidades:
 * - Obtener métricas numéricas y porcentuales de la institución
 * - Actuar como intermediario entre la capa de dominio y la infraestructura
 * - Proveer datos completos para la vista principal del sistema
 *
 * Las métricas incluyen información agregada por sede, jornada y año académico
 */
export class GetMetricsForTheHomeUseCase {
  private metricsForTheHome: HomeRepository;

  /**
   * Inicializa el UseCase con el repositorio de métricas del home
   * @param metricsForTheHome - Repositorio que implementa la interfaz HomeRepository
   */
  constructor(metricsForTheHome: HomeRepository) {
    this.metricsForTheHome = metricsForTheHome;
  }

  /**
   * Ejecuta la obtención de métricas completas del home
   * @returns Promesa con la respuesta de la API conteniendo métricas por año y sede
   * @throws Error si falla la comunicación con el repositorio
   */
  async execute(): Promise<HomeApiResponse> {
    return await this.metricsForTheHome.getMetricsForTheHome();
  }
}
